/* eslint-disable @next/next/no-img-element */

// utils
import { useEffect, useState } from 'react';
import DrawerComponent from '../../drawer/DrawerComponent';
import HistoryComponent from '../../history/HistoryComponent';
import Topo from '../topo/Topo';
import Topo2 from '../topo2/Topo';
import styles from './WelcomePiecesCompany.module.css';

const WelcomePiecesCompany: React.FC<{
    site: any;
    activeDrawer: any;
    setActiveDrawer: any;
    titulo?: string;
    routes?: any;
    bannerListagem?: any;
    favorito: Array<number>;
    props: any;

}> = ({ site, activeDrawer, setActiveDrawer, titulo, routes, favorito, bannerListagem, props }) => {
    const urlBanner = bannerListagem ? bannerListagem?.url : 'https://fotos.sobressai.com.br/Banner/1722/10526.jpg';
    const [vips, setVips] = useState<any>("");

    useEffect(() => {
        if(!vips){
            const vip: any = localStorage.getItem('vip');
            if(vip){
                setVips(vip)
            }
        }
    }, [vips]);

    return (

        <div className={styles.oneStep}>
            <DrawerComponent
                site={site}
                activeDrawer={activeDrawer}
                setActiveDrawer={setActiveDrawer}
                favorito={favorito?.length > 0 ? favorito : []}
                vips={vips}
                menus={props?.siteInit?.menus}
            />
            {site?.modelo_topo == 3 ?
                <div className={styles.header_welcome} style={{padding: 0}}>
                    <Topo2 site={site} setActiveDrawer={setActiveDrawer} setBuscaAvancada={null}/>
                </div>
            : 
                <div className={styles.header_welcome}>
                    <Topo
                        site={site}
                        setActiveDrawer={setActiveDrawer}
                    />
                    <label className={styles.title}>{titulo}</label>
                </div>
            }
            
            {urlBanner || site?.id == "1609" ? <img src={urlBanner} alt="Banner" className={styles.video_render} /> : urlBanner == false ? <img src={"https://fotos.sobressai.com.br/Banner/1722/10526.jpg"} alt="Banner" className={styles.video_render} /> : null}
            {routes ? <HistoryComponent site={site} routes={routes}/> : null}
        </div>
    );
};
export default WelcomePiecesCompany;

